export const generatedWorkspaceLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-research-workspace-ledger",
  "operatingRule": "Research workspaces bind model runs, assumptions, claims, notebooks, evidence hashes, and review gates so customer-facing conclusions remain reproducible.",
  "workspaceCount": 3,
  "blockedWorkspaceCount": 3,
  "evidence": {
    "modelRunLedgerHash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
    "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "sourceRefreshReportHash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
    "sidecarValidationReportHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
    "sidecarWorkOrderPacketHash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4"
  },
  "workspaces": [
    {
      "id": "workspace-investor-feasibility-brief",
      "title": "Investor Feasibility Brief",
      "audience": "Deep-tech investor or strategic foresight reviewer",
      "objective": "Compare the most plausible off-world industrial wedge without treating Mercury-first as a preset conclusion.",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "reviewStage": "beta-review",
      "decisionGate": "Can this become a paid feasibility-intelligence report package?",
      "selectedScenarios": [
        "hybrid",
        "moon-first"
      ],
      "runRefs": [
        {
          "id": "run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "selectedScenarioId": "hybrid",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "claimState": "model-derived-unvalidated"
        },
        {
          "id": "run-conservative-moon-first-2026-06-19",
          "label": "Conservative Moon-first stress run",
          "selectedScenarioId": "moon-first",
          "runHash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
          "claimState": "model-derived-unvalidated"
        }
      ],
      "notebookRefs": [
        {
          "id": "notebook-moon-first",
          "title": "Moon-first industrial bootstrap",
          "artifactIds": [
            "artifact-economics-uncertainty-v1",
            "artifact-materials-process-v1"
          ],
          "openQuestionCount": 4
        },
        {
          "id": "notebook-mercury-orbit",
          "title": "Mercury-orbit energy and thermal trade",
          "artifactIds": [
            "artifact-horizons-geometry-v1",
            "artifact-spice-gf-windows-v1"
          ],
          "openQuestionCount": 4
        }
      ],
      "assumptionRefs": [
        {
          "id": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "state": "approved-governance-rule",
          "testGate": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "id": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "state": "hypothesis",
          "testGate": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        },
        {
          "id": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "state": "validated-product-rule",
          "testGate": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        }
      ],
      "claimRefs": [
        {
          "id": "claim-mercury-flux",
          "status": "Verified",
          "impact": "High",
          "confidence": 0.92,
          "sourceIds": [
            "nasa-mercury"
          ]
        },
        {
          "id": "claim-dtn",
          "status": "Verified",
          "impact": "High",
          "confidence": 0.88,
          "sourceIds": [
            "nasa-dtn"
          ]
        },
        {
          "id": "claim-spf-separation",
          "status": "Likely",
          "impact": "High",
          "confidence": 0.78,
          "sourceIds": [
            "pds"
          ]
        }
      ],
      "evidenceHashes": {
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
        "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
        "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
        "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f",
        "claims": "sha256-61b79784357e725eadaeaa05cb20796bb07c9b99d40d2423120354ee7aabad63",
        "runHashes": "sha256-443271797372507f2e5f7803c7a4a60490edd7c716fc295c2d2f8bf9f0b859d8"
      },
      "decisionRefs": [
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "promotionState": "blocked-for-commercial-proof",
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "promotionState": "blocked-for-commercial-proof",
          "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
        }
      ],
      "reviewGates": [
        {
          "id": "source-evidence",
          "label": "Source evidence complete",
          "status": "pass",
          "detail": "All referenced runs, notebooks, assumptions, and claims resolve."
        },
        {
          "id": "claim-promotion",
          "label": "Claim promotion safe",
          "status": "blocked",
          "detail": "1 workspace claims remain unverified or blocked."
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecar validation",
          "status": "blocked",
          "detail": "No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted."
        },
        {
          "id": "sidecar-work-orders",
          "label": "Sidecar execution packet",
          "status": "pass",
          "detail": "5 sidecar work orders are hash-backed and ready for external worker implementation."
        }
      ],
      "exportPolicy": "Reports may cite this workspace only with workspaceHash, run hashes, evidence hashes, blocked claims, and review gates attached.",
      "workspaceHash": "sha256-39ce4c082cf5d7b374489dc8b8b7a54f6fb0192a04b3f993c9bc499629d3a035"
    },
    {
      "id": "workspace-asteroid-feedstock-screen",
      "title": "Asteroid Feedstock Screen",
      "audience": "Space resources startup, university lab, or aerospace concept team",
      "objective": "Screen asteroid-related scenarios while preserving the rule that close approach does not imply usable composition.",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "reviewStage": "blocked-by-source-depth",
      "decisionGate": "Which candidate-specific taxonomy/spectra/PDS records would change the ranking?",
      "selectedScenarios": [
        "asteroid-first",
        "hybrid"
      ],
      "runRefs": [
        {
          "id": "run-asteroid-feedstock-probe-2026-06-19",
          "label": "Asteroid feedstock uncertainty probe",
          "selectedScenarioId": "asteroid-first",
          "runHash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22",
          "claimState": "model-derived-unvalidated"
        },
        {
          "id": "run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "selectedScenarioId": "hybrid",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "claimState": "model-derived-unvalidated"
        }
      ],
      "notebookRefs": [
        {
          "id": "notebook-asteroid-feedstock",
          "title": "NEA feedstock screening",
          "artifactIds": [
            "artifact-sbdb-cad-screen-v1",
            "artifact-trajectory-sidecar-v1"
          ],
          "openQuestionCount": 4
        }
      ],
      "assumptionRefs": [
        {
          "id": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "state": "approved-governance-rule",
          "testGate": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "id": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "state": "blocked-until-source-backed",
          "testGate": "Taxonomy, spectra, or mission data required before promotion."
        },
        {
          "id": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "state": "validated-product-rule",
          "testGate": "All displayed science claims must resolve to local source records or reviewed artifacts."
        }
      ],
      "claimRefs": [
        {
          "id": "claim-helium3",
          "status": "Hypothesis",
          "impact": "Medium",
          "confidence": 0.25,
          "sourceIds": [
            "pds"
          ]
        },
        {
          "id": "claim-mercury-core",
          "status": "Likely",
          "impact": "High",
          "confidence": 0.7,
          "sourceIds": [
            "nasa-mercury",
            "pds"
          ]
        }
      ],
      "evidenceHashes": {
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
        "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
        "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
        "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f",
        "claims": "sha256-61b79784357e725eadaeaa05cb20796bb07c9b99d40d2423120354ee7aabad63",
        "runHashes": "sha256-9273b2b06fbfd89639e8753e38a6372717ae59bfb8964b26851e0468a77f7bfa"
      },
      "decisionRefs": [
        {
          "scenarioId": "asteroid-first",
          "rank": 3,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 41.63,
          "promotionState": "blocked-for-commercial-proof",
          "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
        },
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "promotionState": "blocked-for-commercial-proof",
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        }
      ],
      "reviewGates": [
        {
          "id": "source-evidence",
          "label": "Source evidence complete",
          "status": "pass",
          "detail": "All referenced runs, notebooks, assumptions, and claims resolve."
        },
        {
          "id": "claim-promotion",
          "label": "Claim promotion safe",
          "status": "blocked",
          "detail": "2 workspace claims remain unverified or blocked."
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecar validation",
          "status": "blocked",
          "detail": "No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted."
        },
        {
          "id": "sidecar-work-orders",
          "label": "Sidecar execution packet",
          "status": "pass",
          "detail": "5 sidecar work orders are hash-backed and ready for external worker implementation."
        }
      ],
      "exportPolicy": "Reports may cite this workspace only with workspaceHash, run hashes, evidence hashes, blocked claims, and review gates attached.",
      "workspaceHash": "sha256-af632045750b3b113f57cdad025a4ea3fe74018460b743bcf69eff71fee3b709"
    },
    {
      "id": "workspace-science-validation-backlog",
      "title": "Science Validation Backlog",
      "audience": "Internal science and engineering validation team",
      "objective": "Track exactly which runtime artifacts must exist before trajectory, event-window, and optimization claims can promote.",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "reviewStage": "engineering-validation",
      "decisionGate": "Which sidecar contract should be converted into a real runtime artifact first?",
      "selectedScenarios": [
        "hybrid"
      ],
      "runRefs": [
        {
          "id": "run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "selectedScenarioId": "hybrid",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "claimState": "model-derived-unvalidated"
        }
      ],
      "notebookRefs": [
        {
          "id": "notebook-mercury-orbit",
          "title": "Mercury-orbit energy and thermal trade",
          "artifactIds": [
            "artifact-horizons-geometry-v1",
            "artifact-spice-gf-windows-v1"
          ],
          "openQuestionCount": 4
        },
        {
          "id": "notebook-moon-first",
          "title": "Moon-first industrial bootstrap",
          "artifactIds": [
            "artifact-economics-uncertainty-v1",
            "artifact-materials-process-v1"
          ],
          "openQuestionCount": 4
        }
      ],
      "assumptionRefs": [
        {
          "id": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "state": "validated-product-rule",
          "testGate": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "id": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "state": "hypothesis",
          "testGate": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        }
      ],
      "claimRefs": [
        {
          "id": "claim-mercury-flux",
          "status": "Verified",
          "impact": "High",
          "confidence": 0.92,
          "sourceIds": [
            "nasa-mercury"
          ]
        },
        {
          "id": "claim-de440-boundary",
          "status": "Verified",
          "impact": "High",
          "confidence": 0.9,
          "sourceIds": [
            "horizons-api",
            "spice-gf"
          ]
        },
        {
          "id": "claim-spf-separation",
          "status": "Likely",
          "impact": "High",
          "confidence": 0.78,
          "sourceIds": [
            "pds"
          ]
        }
      ],
      "evidenceHashes": {
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
        "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
        "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
        "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f",
        "claims": "sha256-61b79784357e725eadaeaa05cb20796bb07c9b99d40d2423120354ee7aabad63",
        "runHashes": "sha256-bf154cfc9d6bf952e6d718b0c5a9ed7ed5906efb4f66987840944f877620e744"
      },
      "decisionRefs": [
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "promotionState": "blocked-for-commercial-proof",
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        }
      ],
      "reviewGates": [
        {
          "id": "source-evidence",
          "label": "Source evidence complete",
          "status": "pass",
          "detail": "All referenced runs, notebooks, assumptions, and claims resolve."
        },
        {
          "id": "claim-promotion",
          "label": "Claim promotion safe",
          "status": "blocked",
          "detail": "1 workspace claims remain unverified or blocked."
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecar validation",
          "status": "blocked",
          "detail": "No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted."
        },
        {
          "id": "sidecar-work-orders",
          "label": "Sidecar execution packet",
          "status": "pass",
          "detail": "5 sidecar work orders are hash-backed and ready for external worker implementation."
        }
      ],
      "exportPolicy": "Reports may cite this workspace only with workspaceHash, run hashes, evidence hashes, blocked claims, and review gates attached.",
      "workspaceHash": "sha256-8cca8a7ea33436d40671577ca25734edbfcbd5eb1533fdfe7149cc3d23dc1e25"
    }
  ],
  "ledgerHash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755"
}
;
